import { render, staticRenderFns } from "./DeleteBill.vue?vue&type=template&id=2e18ae84&scoped=true"
import script from "./DeleteBill.vue?vue&type=script&lang=js"
export * from "./DeleteBill.vue?vue&type=script&lang=js"
import style0 from "./DeleteBill.vue?vue&type=style&index=0&id=2e18ae84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18ae84",
  null
  
)

export default component.exports